import { fetchSearch } from "./sanity";
import { useEffect, useState } from "react";

const debouncedSearch = debounce(onSearch, 300);

export function useSearch(query, locale) {
  const [results, setResults] = useState([]);

  useEffect(() => {
    async function asyncFn() {
      const results = await debouncedSearch(query, locale);
      setResults(results);
    }

    asyncFn();
  }, [query]);

  return results;
}

async function onSearch(query, locale) {
  if (!query || query === "") {
    return [];
  }

  const response = await fetchSearch({ locale, query });
  const results = response.map(({ _type, type, slug, intro, title, name }) => {
    return {
      description: intro,
      href: slug?.current || "",
      title: title || name,
      type: _type,
    };
  });

  return results;
}

function debounce(fn, wait = 100) {
  let timeout = null;

  return function debounced(...args) {
    return new Promise(function (resolve) {
      clearTimeout(timeout);
      timeout = setTimeout(onTimeout, wait);

      async function onTimeout() {
        clearTimeout(timeout);
        const result = await fn(...args);
        resolve(result);
      }
    });
  };
}
